import { RetailerStoryblok } from '../../_shared/interfaces/storyblok';

export const getRetailerForSession = (retailers: RetailerStoryblok[] | undefined): string | undefined => {
    const referrer = sessionStorage.getItem('referrer'); // this was set in gatsby-browser.js
    if (retailers?.length && referrer) {
        sessionStorage.removeItem('referrer');
        const referrerHostname = new URL(referrer).hostname;
        if (referrerHostname && referrerHostname !== self.location.host) {
            const match = retailers.find((retailer) => retailer.hosts.includes(referrerHostname));
            if (match) {
                return match.id;
            } else {
                return;
            }
        }
    }
};

export const isRetailerIdValid = (retailers: RetailerStoryblok[] | undefined, retailerId: string): boolean => {
    if (!retailers) {
        return false;
    } else {
        return !!retailers.find((retailer) => retailer.id === retailerId);
    }
};
